import { Redirect } from 'react-router-dom';
import { getFirstEntry } from '../helpers';

const HomeRoute = () => {
  const route = getFirstEntry();
  return <Redirect to={{ pathname: route }} />;
};

export default HomeRoute;
